import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { TipoRespostaService } from '../../../../../service/configuracao/tipo-resposta.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-filtrar-tipo-resposta',
  templateUrl: './filtro.component.html',
  styleUrls: ['./filtro.component.scss'],
})
export class FiltrarTipoRespostaComponent implements OnInit {
  @Input() itemsPerView: number = 10;

  searchForm: FormGroup;
  searchParams: any = {};
  searchInput: string = '';
  loading: boolean = false;

  debounce: Subject<string> = new Subject<string>();

  visible = '';
  situacao = 'Situação';
  ativo: boolean = null;

  data: any = {
    resultado: [],
    primeiraPagina: true,
    ultimaPagina: false,
    paginaAtual: 1,
    totalPaginas: 1,
    totalDeItems: 0,
    itemsPorPagina: 10
  };

  filterCurrent: any = {
    pagina: 1,
    total_pagina: 10
  };

  allowClearFilter = false;

  constructor(
    private fb: FormBuilder,
    private tipoRespostaService: TipoRespostaService
  ) {
    this.criarFormulario();
  }

  ngOnInit() {
    this.configurarSubject();
    this.searchParams = {
      pagina: 1,
      total_pagina: this.itemsPerView
    };

    this.search();
  }

  criarFormulario() {
    this.searchForm = this.fb.group({
      assunto: ''
    });
  }

  toggleVisibility(item: string) {
    this.visible = (item === this.visible) ? '' : item;
  }

  statusFilter(e: any) {
    this.situacao = e.target.name;
    if (e.target.value === 'true') {
      this.ativo = true;
    } else if (e.target.value === 'false') {
      this.ativo = false;
    } else {
      this.ativo = null;
    }
  }

  onSearchByTitle() {
    this.searchParams['descricao'] = this.searchInput;
    this.searchParams['pagina'] = 1;
    this.search();
  }

  onSearchByStatus() {
    this.searchParams['pagina'] = 1;

    if (this.ativo === null || this.ativo === undefined) {
      delete this.searchParams['ativo'];
    } else {
      this.searchParams['ativo'] = this.ativo;
    }

    this.visible = '';
    this.search();
  }

  limparFiltro(item: string) {
    if (item === 'situacao') {
      this.situacao = 'Situação';
      this.ativo = null;
      delete this.searchParams['ativo'];
    }

    this.searchParams['pagina'] = 1;
    this.data['paginaAtual'] = 1;
    this.search();
  }

  limpar() {
    this.situacao = 'Situação';
    this.ativo = null;
    this.searchInput = '';
    this.searchParams = {};
    this.searchForm.reset();

    this.searchParams['pagina'] = 1;
    this.searchParams['total_pagina'] = this.itemsPerView;

    this.search();
  }

  private search() {
    this.searchParams['total_pagina'] = this.itemsPerView;

    const possuiFiltroAtivo = this.searchParams.hasOwnProperty('ativo');
    this.allowClearFilter = possuiFiltroAtivo;

    if (!possuiFiltroAtivo) {
      this.situacao = 'Situação';
      this.ativo = null;
    }

    if (!this.searchParams['descricao'] || !String(this.searchParams['descricao']).trim()) {
      delete this.searchParams['descricao'];
    }

    this.loading = true;

    this.tipoRespostaService.getSituacaoTipoResposta(this.searchParams).subscribe(
      (res: any) => {
        this.loading = false;
        this.data = res;
      },
      () => {
        this.loading = false;
      }
    );
  }

  private configurarSubject() {
    this.debounce.pipe(debounceTime(500)).subscribe(() => {
      this.onSearchByTitle();
    });
  }
}
